import { useEffect } from "react";

const SITE = "https://lumorasweb.com";
const DEFAULT_TITLE = "Lumora — Siti web in abbonamento";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(url) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = url;
}

export function useSeo({ title, description, path = "/", type = "website", jsonLd = null }) {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : null;
  useEffect(() => {
    const url = `${SITE}${path}`;
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:image", `${SITE}/og-image.jpg`);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertCanonical(url);
    let script = null;
    if (jsonLdStr) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seoDynamic = "1";
      script.textContent = jsonLdStr;
      document.head.appendChild(script);
    }
    return () => {
      document.title = DEFAULT_TITLE;
      if (script) script.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, type, jsonLdStr]);
}
